import { func, object, string } from 'prop-types'
import { useEffect, useState } from 'react'
import { colors } from '@opallabs/spectrum'
import Button from '../../Button'
import { kuiperClassNames } from '../../utils'

import './styles.scss'

const SortControl = ({ displayTitle, onSortClick, sortParams, sortKey }) => {
  const [isSelected, handleIsSelected] = useState(false)

  useEffect(() => {
    if (sortParams.primarySortKey === sortKey) {
      return handleIsSelected(true)
    }
    return handleIsSelected(false)
  }, [sortKey, sortParams.primarySortKey])

  return (
    <div className={kuiperClassNames('sort-control')}>
      <Button
        ariaLabel={`click to sort by ${displayTitle}: ${
          sortParams.isAsc ? 'ascending' : 'descending'
        }`}
        ariaPressed={sortParams.primarySortKey === sortKey}
        icon={`triangle-sm-${isSelected && !sortParams.isAsc ? 'n' : 's'}`}
        iconOptions={{
          style: {
            height: 8,
            width: 8,
            color: isSelected ? colors.n4.base : colors.n7.base,
          },
        }}
        onClick={() => {
          onSortClick(sortKey)
        }}
        type="invisible"
      />
    </div>
  )
}

SortControl.propTypes = {
  displayTitle: string,
  onSortClick: func,
  sortKey: string,
  sortParams: object,
}

export default SortControl
